export type ModelFileTypes = "ply" | "stl";
export const allowedModelFileExts: ModelFileTypes[] = ["ply", "stl"];
export const allowedModelFileTypes: string[] = [".ply", ".stl", "application/sla", "application/pla", "models/stl"];
